import cms from "../../model/cms"

const state = ({
  token: ''
})

const getters = {
  getUserToken: state => state.token
}

const actions = {
  token({ commit }, payload) {
    cms.getUserToken().then((response) => {
      commit('setToken', response.data.token)
    })
  }  
}

const mutations = {
  setToken: (state, payload) => state.token = payload
}

export default {
  state,
  getters,
  actions,
  mutations
}